import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerCignaIcon = lazy(() => import('./svg-components/eiv-payer-cigna-icon'));

const EivPayerCignaIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerCignaIcon {...rest} />
  </Suspense>
);

export default EivPayerCignaIcon;
